import * as Handlebars from 'handlebars';
import moment from 'moment';

export class FtReplacementTokenService {

    replace(
        ftDocument: DisguiseDto.FTDefinitionDto,
        context: any
    ) {
        if (context) {
            Handlebars.registerHelper({
                dateFormat: (dateFormat, contextualBindingOrHelperOptions) => {
                    let currentMoment;
                    if (typeof contextualBindingOrHelperOptions === 'object') {
                        // no contextual binding given. this is just the handlebars configuration
                        currentMoment = moment.utc();
                    } else {
                        // contextual binding given.
                        currentMoment = moment.utc(contextualBindingOrHelperOptions);
                    }

                    return currentMoment.format(dateFormat || 'DD.MM.YYYY');
                },
                dateFormatAdd: (dateFormat, contextualBinding, amount, unit, helperOptions) => {
                    let currentMoment;
                    if (typeof contextualBinding === 'object') {
                        // no contextual binding given. this is just the handlebars configuration
                        currentMoment = moment.utc();
                    } else if (contextualBinding) {
                        // contextual binding given.
                        currentMoment = moment.utc(contextualBinding);
                    } else {
                        currentMoment = moment.utc();
                    }

                    if (amount && unit) {
                        currentMoment = currentMoment.add(amount, unit);
                    }

                    return currentMoment.format(dateFormat || 'DD.MM.YYYY');
                },
                dateFormatSubtract: (dateFormat, contextualBinding, amount, unit, helperOptions) => {
                    let currentMoment;
                    if (typeof contextualBinding === 'object') {
                        // no contextual binding given. this is just the handlebars configuration
                        currentMoment = moment.utc();
                    } else if (contextualBinding) {
                        // contextual binding given.
                        currentMoment = moment.utc(contextualBinding);
                    } else {
                        currentMoment = moment.utc();
                    }

                    if (amount && unit) {
                        currentMoment = currentMoment.add(amount, unit);
                    }

                    return currentMoment.format(dateFormat || 'DD.MM.YYYY');
                }
            });
            if (ftDocument && ftDocument.rows) {
                for (const currentRow of ftDocument.rows) {
                    if (currentRow['@type'] === 'FTRowDto') {
                        if (currentRow.fields) {
                            for (const field of currentRow.fields) {
                                if (field.type === 'FTFieldDto') {
                                    if (field.uiType === 'TEXTAREA' || (field.uiType === 'INPUT' && field.dataType !== 'NUMBER') || field.uiType === 'SIGNATURE') {
                                        const template = Handlebars.compile(field.value || '');
                                        field.value = template(context);
                                    } else if (field.uiType === 'INPUT' && field.dataType === 'NUMBER') {
                                        const castedTypeSpecificSettings = field.typeSpecificSettings as DisguiseDto.NumberFieldSpecificSettings;
                                        if (castedTypeSpecificSettings && castedTypeSpecificSettings.context) {
                                            const template = Handlebars.compile(castedTypeSpecificSettings.context);
                                            field.value = template(context);
                                        }
                                    } else if (field.uiType === 'DATE' && field.dataType === 'ISODATE') {
                                        const castedTypeSpecificSettings = field.typeSpecificSettings as DisguiseDto.DateFieldSpecificSettings;
                                        if (castedTypeSpecificSettings && castedTypeSpecificSettings.context) {
                                            const template = Handlebars.compile(castedTypeSpecificSettings.context);
                                            field.value = template(context);
                                        }
                                    } else if (field.uiType === 'YEAR_MONTH' && field.dataType === 'ISODATE') {
                                        const castedTypeSpecificSettings = field.typeSpecificSettings as DisguiseDto.YearMonthFieldSpecificSettings;
                                        if (castedTypeSpecificSettings && castedTypeSpecificSettings.context) {
                                            const template = Handlebars.compile(castedTypeSpecificSettings.context);
                                            field.value = template(context);
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        throw new Error('Unknown content');
                    }
                }
            }

        }
    }
}
